import React from 'react';
import { Pipeline } from './Pipeline';
import { PracticeOverview } from './PracticeOverview';
import { Tab, TabItemProps } from '$ui/Settings/Tab';

const def: Array<TabItemProps> = [
    {
        icon: 'BarChart2',
        key: 'practice',
        name: 'Practice Overview',
        exact: true,

        component: PracticeOverview
    },
    {
        icon: 'PieChart',
        key: 'pipeline',
        name: 'Pipeline',
        uri: '/reporting/pipeline',
        component: Pipeline
    }
];

export const Reporting = () => {
    return <Tab items={def} path="reporting" active="practice" />;
};
